module.exports = require('./Switch');


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-switch/es/index.js
// module id = 617
// module chunks = 0 1